module.exports = __webpack_public_path__ + "ffb5012601333717cea08ad8eb525a06.png";